import { render } from "./SpangleNotice.vue?vue&type=template&id=501b5a04&scoped=true"
import script from "./SpangleNotice.vue?vue&type=script&lang=js"
export * from "./SpangleNotice.vue?vue&type=script&lang=js"

import "./SpangleNotice.vue?vue&type=style&index=0&id=501b5a04&scoped=true&lang=scss"

import exportComponent from "../../../../../../../jiffyshirts/node_modules/.pnpm/vue-loader@17.4.2_@vue+compiler-sfc@3.5.6_vue@3.5.6_typescript@5.7.3__webpack@5.96.1/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-501b5a04"]])

export default __exports__